import React from 'react'

interface PasswordRequirementItemProps {
  isMet: boolean
  label: string
}

const PasswordRequirementItem: React.FC<PasswordRequirementItemProps> = ({ isMet, label }) => {
  return (
    <div className="relative flex-shrink-0 flex flex-row items-start gap-1">
      <div className="relative flex-shrink-0 w-5 h-5 flex flex-col items-start">
        <div
          className={`absolute flex-shrink-0 top-[3px] bottom-[3px] left-[3px] right-[3px] flex flex-col items-start rounded-[3px] border ${
            isMet ? 'bg-[rgba(0,201,80,1)] border-[rgba(0,201,80,1)]' : 'bg-gray-50 border-white/30'
          }`}
          style={{
            boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.08)'
          }}
        />
        {isMet && (
          <div className="absolute flex-shrink-0 top-[1px] left-0 right-[3px]">
            <svg
              className="absolute flex-shrink-0 top-1 right-[3px] bottom-1 left-[3px] overflow-visible"
              width="15"
              height="13"
              viewBox="0 0 15 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.75 5.67857L5.60714 9.25L11.6786 1.75"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="relative flex-shrink-0 flex flex-col items-start">
        <div className="relative flex-shrink-0 text-left text-white text-xs font-semibold font-Montserrat leading-5">
          {label}
        </div>
      </div>
    </div>
  )
}

export default PasswordRequirementItem
